<template>
  <div class="export-excursion-risk-assessment">
    <cs-button
      id="btnCreateRiskAssessment"
      primary
      testing-id="btnCreateRiskAssessment"
      :loading="riskAssessmentDownloadActionInProgress"
      left-icon="fa:fas fa-exclamation-triangle"
      label="Export Risk Assessment"
      @click="open"
    ></cs-button>
    <cs-form-dialog
      :model-value="exportRiskAssessmentErrorDialogDisplayed"
      heading="Export Risk Assessment"
      :primary-action="{ label: 'OK', eventName: 'primary-click' }"
      @primary-click="exportRiskAssessmentErrorDialogDisplayed = false"
      @update:model-value="exportRiskAssessmentErrorDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        <v-spacer></v-spacer>
        <div v-safe-html="exportRiskAssessmentErrorDialogMessage"></div>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="dlg-export-excursion-risk-assessment"
      v-model="riskAssessmentExportModalDisplayed"
      body-id="dlg-body-export-excursion-risk-assessment"
      heading="Export Risk Assessment"
      :primary-action="{
        label: 'Export PDF',
        eventName: 'primary-click',
        loading: riskAssessmentDownloadActionInProgress
      }"
      :secondary-action1="{
        label: 'Export DOC',
        eventName: 'secondary1-click',
        loading: riskAssessmentDownloadActionInProgress
      }"
      :secondary-action2="{
        label: 'Cancel',
        eventName: 'secondary2-click'
      }"
      @primary-click="exportBtnClicked('pdf')"
      @secondary1-click="exportBtnClicked('docx')"
      @secondary2-click="close"
      @update:model-value="close"
    >
      <template #cs-form-dialog-content>
        <v-container class="export-excursion-policy">
          <div>
            <v-row class="selected-risk-container" no-gutters>
              <v-col cols="1">
                <v-checkbox
                  id="export-excursion-risk-assessment--export-all-checklists"
                  v-model="allChecklistsExported"
                  hide-details
                  class="excursion-policy-row-title-checkbox"
                  color="primary"
                ></v-checkbox>
              </v-col>
              <v-col
                id="export-excursion-risk-assessment--export-all-checklists--label"
                class="excursion-policy-row-title"
                @click="allChecklistsExported = !allChecklistsExported"
              >
                Export All Checklists
              </v-col>
            </v-row>
            <v-row class="selected-risk-container" no-gutters>
              <v-col cols="1">
                <v-checkbox
                  id="export-excursion-risk-assessment--pre-departure-checklist"
                  v-model="predepartureChecklistExported"
                  hide-details
                  class="excursion-policy-row-title-checkbox"
                  color="primary"
                ></v-checkbox>
              </v-col>
              <v-col
                id="export-excursion-risk-assessment--pre-departure-checklist--label"
                class="excursion-policy-row-title"
                @click="predepartureChecklistExported = !predepartureChecklistExported"
              >
                Pre-Departure Checklist
              </v-col>
            </v-row>
            <v-row class="selected-risk-container" no-gutters>
              <v-col cols="1">
                <v-checkbox
                  id="export-excursion-risk-assessment--all-attachments-checkbox"
                  v-model="allAttachmentsExported"
                  hide-details
                  color="primary"
                  class="excursion-policy-row-title-checkbox"
                ></v-checkbox>
              </v-col>
              <v-col
                id="export-excursion-risk-assessment--all-attachments--label"
                class="excursion-policy-row-title"
                @click="allAttachmentsExported = !allAttachmentsExported"
              >
                Include All Attachments
              </v-col>
            </v-row>
          </div>
        </v-container>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="dlg-pre-save-confirmation-export-risk-assessment"
      v-model="preSaveConfirmationDialogDisplayed"
      body-id="dlg-body-pre-save-confirmation-export-risk-assessment"
      heading="Export Risk Assessment"
      :primary-action="{
        label: 'Save',
        eventName: 'primary-click'
      }"
      :secondary-action1="{
        label: 'Cancel',
        eventName: 'secondary1-click'
      }"
      @primary-click="
        preSaveConfirmationDialogDisplayed = false;
        exportContent(true);
      "
      @secondary1-click="
        preSaveConfirmationDialogDisplayed = false;
        exportContent(false);
      "
    >
      <template #cs-form-dialog-content>
        Changes have been made to this excursion. Do you want to save and continue?
      </template>
    </cs-form-dialog>
  </div>
</template>

<script>
import excursionStepperHeading from '../lib/const/excursionStepperHeading';

export default {
  name: 'ExportExcursionRiskAssessment',

  props: {
    excursionPolicyExportActionEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    valuesChanged: {
      type: String,
      required: false,
      default: ''
    },
    registerRiskAssessmentExportEvent: {
      type: Function,
      required: true
    },
    submitExcursion: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      riskAssessmentExportModalDisplayed: false,
      riskAssessmentDownloadActionInProgress: false,
      allChecklistsExported: true,
      preSaveConfirmationDialogDisplayed: false,
      predepartureChecklistExported: false,
      allAttachmentsExported: false,
      exportRiskAssessmentErrorDialogDisplayed: false,
      exportRiskAssessmentErrorDialogMessage: ''
    };
  },

  methods: {
    close() {
      this.riskAssessmentDownloadActionInProgress = false;
      this.riskAssessmentExportModalDisplayed = false;
    },

    async open() {
      try {
        await this.validateExcursionHighRiskStudentMedicalSetting();
        this.allChecklistsExported = true;
        this.predepartureChecklistExported = false;
        this.allAttachmentsExported = false;
        this.riskAssessmentExportModalDisplayed = true;
      } catch (error) {
        this.exportRiskAssessmentErrorDialogMessage = error.message;
        this.exportRiskAssessmentErrorDialogDisplayed = true;
      }
    },

    async validateExcursionHighRiskStudentMedicalSetting() {
      const excursionStatus = this.$store.state.common.excursionDc.status;
      if (excursionStatus !== 'draft') {
        return;
      }

      this.validateClientSetup(this.$store.state.common.excursionDc.client);
    },

    validateClientSetup(clientSetup) {
      if (!clientSetup.excursionAdditionalInformationEnabled) {
        throw new Error(
          `"Additional Information" step is expected. Please check with your administrator to enable it in client options.`
        );
      }
      if (!clientSetup.excursionHighRiskStudentMedicalEnabled) {
        return;
      }
      const { currentStep } = this.$store.state.common.excursionDc;
      if (clientSetup.excursionHighRiskStudentMedicalEnabled && currentStep < 5) {
        throw new Error(
          `"Student Medical and Ratios" step is expected when high-risk student medical option is enabled. Please check with your administrator or make a new excursion with latest client's settings.`
        );
      }
    },

    async downloadAssessment(format) {
      this.riskAssessmentDownloadActionInProgress = true;

      if (typeof this.registerRiskAssessmentExportEvent === 'function') {
        this.registerRiskAssessmentExportEvent();
      }

      const excursionMetadata = JSON.parse(JSON.stringify(this.$store.state.common.excursionDc));

      const { query } = this.$route;
      const clientLogoEnabled = !(query && query.referrer && query.referrer === 'pcg');

      const excursionCommonAdapter = new this.$app.excursionCommon.Adapter({
        store: this.$store,
        app: this.$app
      });

      await excursionCommonAdapter.downloadAssessment(
        excursionMetadata.id,
        query,
        this.allChecklistsExported,
        clientLogoEnabled,
        this.predepartureChecklistExported,
        this.allAttachmentsExported,
        format,
        this.$app.deviceDetector
      );

      this.close();
    },
    exportBtnClicked(format) {
      this.displayPreSaveConfirmationDialog(format);
    },

    async displayPreSaveConfirmationDialog(format) {
      if (
        this.submitExcursion &&
        typeof this.submitExcursion === 'function' &&
        this.valuesChanged &&
        this.valuesChanged !== 'excursionUpdateThenRiskAssessmentExport'
      ) {
        this.preSaveConfirmationDialogDisplayed = true;
      } else {
        if (
          this.submitExcursion &&
          typeof this.submitExcursion === 'function' &&
          this.valuesChanged === 'excursionUpdateThenRiskAssessmentExport'
        ) {
          await this.submitExcursion(
            null,
            true,
            null,
            'excursionUserRatingSync',
            excursionStepperHeading.EXCURSION_RISK_ASSESSMENT
          );
        }
        await this.downloadAssessment(format);
      }
    },

    async exportContent(preSaveConfirmed) {
      if (preSaveConfirmed) {
        this.riskAssessmentDownloadActionInProgress = true;
        this.submitExcursion('downloadExcursionRiskAssessment', false, async () => {
          await this.downloadAssessment();
        });
      }
    }
  }
};
</script>
<style scoped>
.export-excursion-risk-assessment .v-btn {
  margin-left: 0px;
}

.selected-risk-container {
  max-height: 400px;
  height: 40px;
}

.excursion-policy-row-title {
  line-height: 60px;
  cursor: pointer;
  margin-left: 10px;
}

.excursion-policy-row-title:hover {
  cursor: pointer;
}
</style>
